<div class="vf-img-upload-backdrop"
     #backdropEl
     [class.is-open]="open"
     (click)="onBackdropClick($event)">
    <div class="vf-img-upload-dialog" role="dialog" aria-modal="true" *ngIf="open">

        <!-- Header -->
        <div class="d-flex align-items-center justify-content-between"
             style="padding:20px 24px 14px;border-bottom:1px solid #E5E7EB;">
            <span class="font-weight-semibold text-gray-900 f-size-16">Upload files</span>
            <button type="button" class="vf-modal-close-btn"
                    [disabled]="isUploading"
                    (click)="onCancel()" aria-label="Close">
                <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
            </button>
        </div>

        <!-- Body -->
        <div style="padding:16px 24px;background:#F9FAFB;overflow-y:auto;max-height:calc(85vh - 120px);">

            <!-- File tile -->
            <div *ngIf="file">
                <span class="f-size-14 text-gray-700 d-block" style="margin-bottom:12px;">1 file selected</span>
                <div class="vf-img-upload-file-tile">
                    <div class="vf-img-upload-file-thumb">
                        <img *ngIf="previewUrl" [src]="previewUrl" alt=""
                             (error)="onPreviewError()" />
                        <img *ngIf="!previewUrl && fileBrandIconUrl" [src]="fileBrandIconUrl"
                             alt="" style="width:32px;height:32px;object-fit:contain;" />
                        <lucide-icon *ngIf="!previewUrl && !fileBrandIconUrl" [name]="fileIconName"
                                     [size]="32" [strokeWidth]="1.5"></lucide-icon>
                    </div>
                    <div class="vf-img-upload-file-name" [attr.title]="file?.name">{{ file?.name }}</div>
                    <div class="vf-img-upload-file-size">{{ formatSize(file?.size || 0) }}</div>
                </div>
            </div>

            <!-- Choose where to save -->
            <div style="margin-top:16px;">
                <div class="d-flex align-items-center justify-content-between" style="margin-bottom:12px;">
                    <span class="f-size-14 text-gray-700">Choose where to save files</span>
                    <button type="button"
                            class="d-flex align-items-center f-size-12 text-gray-600 rounded-sm cursor-pointer"
                            style="padding:4px 10px;border:1px solid #D1D5DB;gap:6px;white-space:nowrap;background:transparent;"
                            [disabled]="isUploading"
                            (click)="openBrowseFolder()">
                        <lucide-icon name="folder-search" [size]="14" [strokeWidth]="2"></lucide-icon>
                        Browse other locations
                    </button>
                </div>

                <!-- Browsed folder (shown as a sticky selected row above the suggested list) -->
                <div *ngIf="browsedFolder" class="bg-pure-white rounded-sm"
                     style="border:1px solid #E5E7EB;overflow:hidden;margin-bottom:12px;">
                    <div class="d-flex align-items-center cfm-folder-row"
                         [class.cfm-folder-row-selected]="browsedFolder === selectedRow"
                         (click)="selectRow(browsedFolder)">
                        <img *ngIf="browsedFolder.folder?.isOneDrive"
                             src="https://cdn.trovve.com/vfapp/images/app-icons/Onedrive.svg"
                             style="width:20px;flex-shrink:0;" alt="onedrive" />
                        <img *ngIf="!browsedFolder.folder?.isOneDrive"
                             src="https://cdn.trovve.com/vfapp/images/app-icons/SharePoint.svg"
                             style="width:20px;flex-shrink:0;" alt="sharepoint" />
                        <div style="min-width:0;flex:1;margin-left:12px;">
                            <span class="f-size-14 font-weight-medium"
                                  [ngClass]="browsedFolder === selectedRow ? 'text-blue-600' : 'text-gray-900'">
                                {{ browsedFolder.label }}
                            </span>
                            <div *ngIf="browsedFolder.breadcrumb" class="d-flex align-items-center"
                                 style="margin-top:4px;gap:2px;overflow:hidden;">
                                <ng-container *ngFor="let segment of splitBreadcrumb(browsedFolder.breadcrumb); let last = last">
                                    <span class="f-size-12 text-gray-400" style="flex-shrink:0;">{{ segment }}</span>
                                    <lucide-icon *ngIf="!last" name="chevron-right"
                                                 [size]="12" [strokeWidth]="2"
                                                 class="text-gray-300" style="flex-shrink:0;"></lucide-icon>
                                </ng-container>
                            </div>
                        </div>
                        <lucide-icon *ngIf="browsedFolder === selectedRow" name="check"
                                     [size]="16" [strokeWidth]="2"
                                     style="flex-shrink:0;color:#2563EB;"></lucide-icon>
                    </div>
                </div>

                <!--
                    Loading skeleton. Shimmer rows only: this used to render a blue-checked OneDrive row on
                    top, which read as "OneDrive is your destination" before the project folders had even
                    arrived. Nothing is offered as selected until the real list renders.
                -->
                <div *ngIf="isLoadingFolders" class="bg-pure-white rounded-sm"
                     style="border:1px solid #E5E7EB;overflow:hidden;">
                    <div style="padding:12px 16px;">
                        <div class="skeleton-shimmer" style="height:14px;width:60%;margin-bottom:8px;"></div>
                        <div class="skeleton-shimmer" style="height:14px;width:80%;margin-bottom:8px;"></div>
                        <div class="skeleton-shimmer" style="height:14px;width:50%;"></div>
                    </div>
                </div>

                <!-- Folder list -->
                <div *ngIf="!isLoadingFolders" class="bg-pure-white rounded-sm"
                     style="border:1px solid #E5E7EB;overflow:hidden;">
                    <ng-template ngFor let-row [ngForOf]="folders">
                        <div class="d-flex align-items-center cursor-pointer cfm-folder-row"
                             [class.cfm-folder-row-selected]="row === selectedRow"
                             (click)="selectRow(row)">

                            <img *ngIf="row.kind === 'onedrive'"
                                 src="https://cdn.trovve.com/vfapp/images/app-icons/Onedrive.svg"
                                 style="width:20px;flex-shrink:0;" alt="onedrive" />
                            <lucide-icon *ngIf="row.kind === 'folder'" name="folder"
                                         [size]="20" [strokeWidth]="2"
                                         style="flex-shrink:0;"
                                         [ngClass]="row === selectedRow ? 'text-blue-600' : 'text-gray-400'"></lucide-icon>

                            <div style="min-width:0;flex:1;margin-left:12px;">
                                <div class="d-flex align-items-center" style="gap:8px;">
                                    <span class="f-size-14 font-weight-medium"
                                          [ngClass]="row === selectedRow ? 'text-blue-600' : 'text-gray-900'">
                                        {{ row.label }}
                                    </span>
                                    <span *ngIf="row.isMain"
                                          class="f-size-10 font-weight-medium rounded-sm"
                                          style="padding:2px 6px;background:#FEFCE8;color:#A16207;border:1px solid #FDE68A;white-space:nowrap;">
                                        Main folder
                                    </span>
                                </div>
                                <div *ngIf="row.breadcrumb" class="d-flex align-items-center"
                                     style="margin-top:4px;gap:2px;overflow:hidden;">
                                    <ng-container *ngFor="let segment of splitBreadcrumb(row.breadcrumb); let last = last">
                                        <span class="f-size-12 text-gray-400" style="flex-shrink:0;">{{ segment }}</span>
                                        <lucide-icon *ngIf="!last" name="chevron-right"
                                                     [size]="12" [strokeWidth]="2"
                                                     class="text-gray-300" style="flex-shrink:0;"></lucide-icon>
                                    </ng-container>
                                </div>
                            </div>

                            <lucide-icon *ngIf="row === selectedRow" name="check"
                                         [size]="16" [strokeWidth]="2"
                                         style="flex-shrink:0;color:#2563EB;"></lucide-icon>
                        </div>
                    </ng-template>
                </div>
            </div>

            <!-- Copy link checkbox -->
            <div class="bg-pure-white rounded-sm"
                 style="border:1px solid #E5E7EB;padding:12px 16px;margin-top:16px;">
                <div class="custom-control custom-checkbox custom-checkbox-blue d-flex align-items-center"
                     style="min-height:auto;">
                    <input type="checkbox" id="vfImgUploadCopyLink" name="vfImgUploadCopyLink"
                           class="custom-control-input"
                           [(ngModel)]="copyLinkToDescription"
                           [disabled]="isUploading" />
                    <label class="custom-control-label f-size-14 text-gray-700 font-weight-normal"
                           style="padding-top:3px;"
                           for="vfImgUploadCopyLink">Copy link to description</label>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="d-flex align-items-center justify-content-end"
             style="padding:12px 24px;border-top:1px solid #E5E7EB;gap:8px;flex-shrink:0;">
            <button type="button" class="vf-modal-cancel-btn"
                    [disabled]="isUploading"
                    (click)="onCancel()">Cancel</button>
            <button type="button" class="btn btn-black rounded-sm f-size-14"
                    style="height:32px;padding:0 16px;"
                    [disabled]="!file || !selectedRow || isUploading"
                    (click)="onUpload()">
                {{ isUploading ? 'Uploading...' : 'Upload' }}
            </button>
        </div>
    </div>

    <!--
        Browse other locations: opens the existing vf-file-selector as a folder picker.
        Always rendered (no *ngIf) because FileSelectorComponent.ngOnChanges accesses
        its `customModal` ViewChild — that ref only exists after view init, so the
        component must mount BEFORE `showPopup` flips to true.
    -->
    <vf-file-selector [showPopup]="showBrowseFolderSelector"
                      [isSingleSelect]="true"
                      [showFolderOnly]="true"
                      [canSelectLibrary]="true"
                      (selectedItems)="onBrowseFolderSelected($event)"
                      (onClose)="onBrowseFolderClose()">
    </vf-file-selector>
</div>
